// Angular imports
import { OnDestroy, OnInit } from '@angular/core';

// 3rd party imports
import { Subscription } from 'rxjs';

// CC-Common imports
import { CCLocalStorageCategory, CCLocalStorageService } from 'cc-common';

// Component imports
import { IInteractiveDashboardComponent } from '../dashboard-module/_interfaces/interactive-dashboard-component';

// Service imports
import { ContextManagerService } from '../_services/data-services/context-manager.service';
import { WidgetContextFactoryService } from '../_services/data-services/widget-context-factory.service';

// Constant imports
import { StorageKeyConstants } from '../_constants/storage-key-constants';

// Model imports
import { PropertyCommunityInfoResultDto } from '../_models/property-community-info-result-dto';

export abstract class MPBaseDashboardWidgetComponent implements OnInit, OnDestroy, IInteractiveDashboardComponent {
    hideTitle = true;
    minWidthRatio = 15;
    minHeightRatio = 25;
    minWidth = 460;
    minHeight = 380;
    hideFullScreen = true;
    widgetId: string;

    currentPaletteName: string;
    currentPaletteMode: string;
    loadingCompleted = false;
    loadingVisible = false;
    sizeGroup = 'pieChartGroup';
    chartWidth: number = undefined;
    chartHeight: number = undefined;

    contextSubscription: Subscription;

    constructor(
        protected readonly contextService: ContextManagerService,
        protected readonly widgetContextFactory: WidgetContextFactoryService,
        protected readonly localStorageService: CCLocalStorageService
    ) {}

    refresh(width: number, height: number): void {
        if (this.loadingCompleted) {
            this.chartWidth = width - 10;
            this.chartHeight = height;
            this.loadingCompleted = false;
            setTimeout(() => (this.loadingCompleted = true), 500);
        }
    }

    getTitle(name: string): string {
        return name.replace('Summary', '').trim();
    }

    ngOnInit(): void {
        this.currentPaletteName = this.localStorageService.getItem(
            StorageKeyConstants.chartPaletteKey,
            CCLocalStorageCategory.CHART
        );
        this.currentPaletteMode = this.localStorageService.getItem(
            StorageKeyConstants.chartPaletteExtentionKey,
            CCLocalStorageCategory.CHART
        );
        const context: PropertyCommunityInfoResultDto = this.contextService.getSelectedContext();
        this.populateDashboardData(context);

        this.contextSubscription = this.contextService.getContext().subscribe((ctx: PropertyCommunityInfoResultDto) => {
            if (!!ctx) {
                this.populateDashboardData(ctx);
            }
        });
    }

    ngOnDestroy(): void {
        if (!!this.contextSubscription) {
            this.contextSubscription.unsubscribe();
        }
    }

    abstract populateDashboardData(context?: PropertyCommunityInfoResultDto): void;
}
